
import React, { useEffect, useState } from 'react'
import as233 from '../images/as233.jpeg'
import as13 from '../images/as13.jpeg'
import as18 from '../images/as18.jpeg'
import as19 from '../images/as19.jpeg'
import as21 from '../images/as21.jpeg'
import as22 from '../images/as22.jpeg'
import as16 from '../images/as16.jpeg'
import as6 from '../images/as6.jpeg'
import as91 from '../images/as91.jpg'
import as123 from '../images/as123.jpg'
import as4 from '../images/as4.jpeg'
const Home = () => {
const[text,settext] = useState('')


 useEffect(() => {
   let word = 'Наши работы'
 let index = 0
let interval  = setInterval(() => {
settext(word.slice(0 , index += 1))
   if (index == word.length) {
    clearInterval(interval)
   }
   },200)
  },[])
 
 
 return (
    <div>
      <main>
       <header className='hed'>
        <img src={as4} alt=""  height='600px'/>
       </header>
       
       
        <section className='text'>
      <h2 style={{textAlign:'center'}}>{text}<span>|</span></h2>
        </section>
        <section className='gridbox'>
      <div className="card1"><img src={as233} alt="" /></div>
      <div className="card2"><img src={as13} alt="" /></div>
      <div className="card3"><img src={as18} alt="" /></div>
      <div className="card4"><img src={as19} alt="" /></div>
      <div className="card5"><img src={as21} alt="" /></div>
      <div className="card6"><img src={as22} alt="" /></div>
        </section>

      </main>
    </div>
  )
}

export default Home

